import { ReactElement } from 'react';
import {
  HAS_APPS_BY_PRODUCT_FAMILY,
  HAS_NO_ANNUAL_BY_PRODUCT,
  ICONS_BY_PRODUCT_NAME,
  PLANS_BY_PRODUCT_NAME,
  UNIT_NAME_BY_PRODUCT_NAME
} from '../../constants';
import { ProductFamilyName } from '../../models';
import {
  useSelectedMarketplaceApps,
  useSelectedProductNames,
  useAppErrors
} from '../../selectors';
import ProductCard from './product-card';
import {
  productIconStyle,
  familyContainer,
  familyHeaderStyle,
  familyLogoWrapperStyle,
  productHeaderContainer,
  productLogoNameContainer
} from './product-family-container.styles';
import MarketplaceAppSelector from '../marketplace-app-selector/marketplace-app-selector';
import AppCard from '../marketplace-app-selector/app-card/app-card';
import AppErrorCard from '../marketplace-app-selector/app-card/app-error-card';
import HighestUnitCountDisclaimer from '../marketplace-app-selector/app-card/highest-unit-count-disclaimer';
import { useModuleProps } from '../../module-props';

export interface ProductFamilyContainerProps {
  name: ProductFamilyName;
  icon: ReactElement;
}

const ProductFamilyContainer = ({
  name,
  icon
}: ProductFamilyContainerProps) => {
  const [selectedProductNames] = useSelectedProductNames(name);
  const [selectedMarketplaceAddons] = useSelectedMarketplaceApps(name);
  const { productsLabel } = useModuleProps();
  const [appErrors] = useAppErrors();

  return (
    <div css={familyContainer}>
      <header css={productHeaderContainer}>
        <div css={productLogoNameContainer}>
          <div css={familyLogoWrapperStyle}>
            <div css={productIconStyle}>{icon}</div>
          </div>
          <div css={familyHeaderStyle}>
            {name === 'Jira products' ? `Jira ${productsLabel}` : name}
          </div>
        </div>
        {HAS_APPS_BY_PRODUCT_FAMILY[name] && (
          <MarketplaceAppSelector parentProductName={name} />
        )}
      </header>
      {selectedProductNames.map((productName) => (
        <ProductCard
          key={productName}
          name={productName}
          icon={ICONS_BY_PRODUCT_NAME[productName]}
          plans={PLANS_BY_PRODUCT_NAME[productName] || []}
          planOptions={(PLANS_BY_PRODUCT_NAME[productName] || []).map(
            ({ name }) => ({
              label: name,
              value: name
            })
          )}
          productFamilyName={name}
          unitName={UNIT_NAME_BY_PRODUCT_NAME[productName] || 'USER'}
          noAnnualPlan={HAS_NO_ANNUAL_BY_PRODUCT[productName]}
        />
      ))}
      {Array.from(selectedMarketplaceAddons).map((app, idx) => (
        <AppCard
          key={app.name + '-' + idx}
          app={app}
          productFamilyName={name}
        />
      ))}
      {Array.from(appErrors).map(([appName, errorMessage], idx) => (
        <AppErrorCard
          key={`${appName}-${idx}`}
          appName={appName}
          errorMessage={errorMessage}
        />
      ))}

      <HighestUnitCountDisclaimer productFamilyName={name} />
    </div>
  );
};

export default ProductFamilyContainer;
